/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentVersionsGetAgentVersion } from "../../funcs/agentVersionsGetAgentVersion.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAgentVersionRequest$inboundSchema,
};

export const tool$agentVersionsGetAgentVersion: ToolDefinition<typeof args> = {
  name: "agent-versions-get-agent-version",
  description: `Retrieve an agent version`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentVersionsGetAgentVersion(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
